export const TOGGLE_SIDE_BAR_ACTION_TYPE: string = 'TOGGLE_SIDE_BAR'

export const TOGGLE_SIDE_BAR = () => {
    return {
        type: TOGGLE_SIDE_BAR_ACTION_TYPE,
    }
}
